import { Checkbox, FormControlLabel, Grid, InputAdornment, MenuItem, Switch, TextField } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { Procedure } from 'types/procedure';
import { ProcedureValidation } from '../validation/useProcedureValidation';
import PercentInput from 'components/masked-input/PercentInput';
import { asInputComponent } from 'components/masked-input/asInputComponent';

interface ProcedureFormProps {
  procedure: Procedure;
  handleChange: (index: keyof Procedure, value: any) => void;
  validation: ProcedureValidation;
  type?: 'edit' | 'new';
}

const ProcedureForm: React.FC<ProcedureFormProps> = ({ procedure, handleChange, validation, type }) => {
  const inputs = {
    name: useRef<HTMLInputElement>(null),
    profit_margin: useRef<HTMLInputElement>(null),
  };

  useEffect(() => {
    const [key] = Object.keys(validation) as [keyof typeof inputs];

    if (!key) return;

    inputs[key].current?.focus();
  }, [validation]);

  return (
    <Grid container size={12} spacing={2} maxWidth={1200}>
      <Grid size={{ xs: 12, lg: 9 }}>
        <TextField
          fullWidth
          autoFocus
          inputRef={inputs.name}
          label="Nome do procedimento"
          placeholder="Digite o nome do procedimento"
          value={procedure.name}
          onChange={e => handleChange('name', e.target.value)}
          error={!!validation.name}
          helperText={validation.name}
        />
      </Grid>

      <Grid size={{ xs: 12, lg: 3 }}>
        <TextField
          fullWidth
          inputRef={inputs.profit_margin}
          label="Margem de lucro"
          placeholder="Digite a margem de lucro"
          value={procedure.profit_margin}
          onChange={e => handleChange('profit_margin', e.target.value)}
          error={!!validation.profit_margin}
          helperText={validation.profit_margin}
          slotProps={{
            input: {
              inputComponent: asInputComponent(PercentInput),
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            },
          }}
        />
      </Grid>

      <Grid size={12} />

      <Grid size={12}>
        <FormControlLabel
          label="Ativo"
          control={
            <Switch checked={!!procedure.active} onChange={e => handleChange('active', e.target.checked ? 1 : 0)} />
          }
        />
      </Grid>
    </Grid>
  );
};

export default ProcedureForm;
